export default __webpack_public_path__ + "bondhushava-colored.png";